<template>
  <div>
    <ul
      :class="$style.gridList"
      :data-test-id="$testId('useCaseList')"
    >
      <li
        v-for="(useCase, index) in useCases"
        :key="`${useCase.label}-${index}`"
        :class="$style.item"
      >
        <UseCaseCard
          :selected="selected"
          :useCase="useCase"
          @click="handleClick"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import UseCaseCard from './UseCaseCard.vue';

export default {
  name: 'UseCaseGrid',

  components: {
    UseCaseCard,
  },

  props: {
    selected: {
      type: String,
      default: '',
    },

    useCases: {
      type: Array,
      required: true,
    },
  },

  methods: {
    handleClick(useCase) {
      if (useCase.label === this.selected) {
        this.$emit('useCaseSelected', false, useCase);
      } else {
        this.$emit('useCaseSelected', true, useCase);
      }
    },
  },
};
</script>

<style module scoped>
  .gridList {
    display: flex;
    flex-wrap: wrap;
    gap: var(--jc-spacer);
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .item {
    height: 120px;
    width: 270px;
  }
</style>
